import * as React from "react";

import {Text} from "@khanacademy/wonder-blocks-core";

import styles from "./styles.ts";
import type {Props} from "./types.ts";

type DefaultProps = {
    tag: Props["tag"];
};

export default class SansSerifAttribution extends React.Component<Props> {
    static defaultProps: DefaultProps = {
        tag: "span",
    };

    render(): React.ReactNode {
        const {style, children, ...otherProps} = this.props;
        return (
            <Text {...otherProps} style={[styles.SansSerifAttribution, style]}>
                {children}
            </Text>
        );
    }
}
